export const GROUP_A = [
  [{ ratioGroupCode: 'AssetsQuality' }, { ratioGroupCode: 'FundingLiquidity' }],
  [{ ratioCode: 'FA146' }, { ratioCode: 'RT0353' }],
  [{}, { ratioCode: 'RT0415' }],
]

export const GROUP_B = [
  [{ ratioGroupCode: 'BusinessGrowth' }, { ratioGroupCode: 'EarningQuality' }],
  [{ ratioCode: 'RT0296' }, { ratioCode: 'FA150' }],
  [{ ratioCode: 'FA151' }, { ratioCode: 'RT0252' }],
  [{ ratioCode: 'RT0172' }, { ratioCode: 'RT0059' }],
  [{ ratioGroupCode: 'AssetsQuality' }, {}],
  [{ ratioCode: 'FA110' }, {}],
]
